module.exports = __webpack_public_path__ + "static/media/ppiel-marron.e71fcb8c.png";